import { useSelector } from 'react-redux';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { useMemo } from 'react';

import { AI_CHATS, ASSISTANT_TYPES, AI_MEDIA_TYPES } from '../../../constants';
import { ICONS } from '../../../icons';
import { MAP_AI_CHATS_TO_LABELS } from '../../../utils/getAiChatsOptionsFromArray';

import scss from './AssistantFields.module.scss';

const usePlaygroundOptions = () => {
  const assistants = useSelector((state) => state.aiPlayground.assistantsData);
  const aiChats = useSelector((state) => state.aiPlayground.aiChats);
  const mediaTypes = useSelector((state) => state.aiPlayground.mediaTypes);

  const formattedAssistants = useMemo(
    () =>
      assistants?.map((assistant) => {
        const icon = getAssistantsIcons(assistant.type);
        return {
          value: assistant.id,
          label: assistant.name,
          ...icon,
          ...assistant,
        };
      }),
    [assistants],
  );

  const formattedAiChats = useMemo(
    () =>
      aiChats?.map((aiChat) => {
        const icon = getAssistantsIcons(aiChat);
        return {
          value: aiChat,
          label: MAP_AI_CHATS_TO_LABELS[aiChat],
          type: AI_CHATS[aiChat],
          ...icon,
        };
      }),
    [aiChats],
  );

  const formattedMediaTypes = useMemo(
    () =>
      mediaTypes?.map((mediaType) => {
        const icon = getAssistantsIcons(mediaType);
        return {
          value: mediaType,
          label: mediaType,
          type: AI_MEDIA_TYPES[mediaType],
          ...icon,
        };
      }),
    [mediaTypes],
  );

  return [...formattedAiChats, ...formattedMediaTypes, ...formattedAssistants];
};

export default usePlaygroundOptions;

const getAssistantsIcons = (type) => {
  switch (type) {
    case ASSISTANT_TYPES.FILE:
      return {
        icon: ICONS.SaveFile,
        isStrokeIcon: false,
        iconClassName: scss.typeDropdownIconRed,
      };
    case ASSISTANT_TYPES.TEXT:
      return {
        icon: ICONS.T,
        isStrokeIcon: true,
        iconClassName: scss.typeDropdownIconGreen,
      };
    case AI_CHATS.ANTHROPIC:
    case AI_CHATS.OPEN_AI:
    case AI_CHATS.GEMINI:
    case AI_CHATS.PERPLEXITY:
      return {
        icon: ChatBubbleOutlineRoundedIcon,
        isStrokeIcon: false,
        iconClassName: scss.typeDropdownIconChat,
      };
    case AI_MEDIA_TYPES.VIDEO:
      return {
        icon: VideocamOutlinedIcon,
        isStrokeIcon: false,
        iconClassName: scss.typeDropdownIconVideo,
      };
    case AI_MEDIA_TYPES.IMAGE:
      return {
        icon: ImageOutlinedIcon,
        isStrokeIcon: false,
        iconClassName: scss.typeDropdownIconImage,
      };
    default:
      return {
        icon: ICONS.T,
        isStrokeIcon: true,
        iconClassName: scss.typeDropdownIconGreen,
      };
  }
};
